import React from 'react';
import Select from 'react-select';

const DuePaymentModal = ({ isOpen, setIsOpen }) => {
    if (!isOpen) return null;

    const students = [
        { value: 'student1', label: 'Student 1' },
        { value: 'student2', label: 'Student 2' },
    ];

    const paymentMethods = [
        { value: 'credit', label: 'Credit Card' },
        { value: 'debit', label: 'Debit Card' },
        { value: 'paypal', label: 'PayPal' },
    ];

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Student Payment Details</h2>
                <form className="oms-modal-form">
                    <div className="oms-form-group">
                        <label htmlFor="student" className="oms-form-label">
                            Select Student
                        </label>
                        <Select options={students} placeholder="Select a student" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="amount" className="oms-form-label">Amount</label>
                        <input type="number" id="amount" placeholder="Enter amount" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="paymentMethod" className="oms-form-label">
                            Payment Method
                        </label>
                        <Select options={paymentMethods} placeholder="Select payment method" />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DuePaymentModal;
